import {
  matchPreRankLoad, matchFinalRankLoad
} from "../../../../services/api/match-rank";
import {
  UPDATE_PRE_RANK, UPDATE_FINAL_RANK, UPDATE_WINNERS
} from "../../../mutation-types";
import { matchWinnersRankLoad } from "../../../../services/api/match-winners";

// 决赛排名
async function loadFinalRank({
  rootState,
  commit
}, {
  page,
  pageNum
}) {
  const {
    cId
  } = rootState
  page = page > 0 ? +page : 1
  pageNum = pageNum > 0 ? +pageNum : 10
  // console.log(cId);
  const R = await matchFinalRankLoad({
    cId,
    page,
    pageNum
  })
  const {
    list,
    total,
    userMap
  } = R
  commit(UPDATE_FINAL_RANK, {
    page,
    pageNum,
    list,
    total,
    userMap
  })
  return R
}

// 初赛排名
async function loadPreRank({
  rootState,
  commit
}, {
  type,
  page,
  pageNum
}) {
  page = page > 0 ? +page : 1
  pageNum = pageNum > 0 ? +pageNum : 10
  const {
    cId
  } = rootState
  const R = await matchPreRankLoad({
    type,
    cId,
    page,
    pageNum
  })
  const {
    list,
    total,
    userMap
  } = R
  commit(UPDATE_PRE_RANK, {
    type,
    page,
    pageNum,
    list,
    total,
    userMap
  })
  return R
}

// 获奖者
async function loadWinners({
  rootState,
  commit
}) {
  const {cId} = rootState
  const R = await matchWinnersRankLoad({cId})
  commit(UPDATE_WINNERS, R)
  return R
}

export default {
  loadFinalRank,
  loadPreRank,
  loadWinners
}
